import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvMessageComponent } from '@marv/components';
import { MissionItem, MissionItemComponent } from '@app/components';

@Component({
    selector: 'app-planning-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonInfiniteScroll, IonInfiniteScrollContent, TranslatePipe, forwardRef(() => MarvMessageComponent), forwardRef(() => MissionItemComponent)
    ]
})
export class PlanningListComponent  implements OnInit {

    @Input({alias : 'missions', required : true}) missionsItems: Array<MissionItem> = [];
    @Output() onSelectMission = new EventEmitter<MissionItem>();
    @Output() onEvaluateMission = new EventEmitter<MissionItem>();
    
    missionsItemsDisplayed: Array<MissionItem> = [];
    maxMissionsDisplayed: number = 50;
    indexMissionDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;

    constructor() { }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if(changes['missionsItems']){
            this.missionsItemsDisplayed = [];
            this.indexMissionDisplayed = 0;
            this.disabledInfiniteScroll = false;
            this.getMissionsDisplayed();
        }
    }
    
    getMissionsDisplayed() {
        let subArray = this.missionsItems.slice(this.indexMissionDisplayed, this.indexMissionDisplayed+this.maxMissionsDisplayed);
        if(subArray.length > 0){
            this.missionsItemsDisplayed = this.missionsItemsDisplayed.concat(subArray);
            this.indexMissionDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
    }
    
    onIonInfinite(event: InfiniteScrollCustomEvent) { 
        this.getMissionsDisplayed();
        event.target.complete();
    }
    
    selectMission(missionItem: MissionItem){
        this.onSelectMission.emit(missionItem);
    }
    
    evaluateMission(missionItem: MissionItem){
        this.onEvaluateMission.emit(missionItem);
    }
}
